import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { chatbotActions } from '../store';
import {
  getDisclaimerAccepted,
  setDisclaimerAccepted,
} from '../utils/sessionStorage';
import LeftColumnContent from './components/LeftColumnContent';
import RightColumnContent from './components/RightColumnContent';
import useSkipLinkFix from './hooks/useSkipLinkFix';

/**
 * Chatbot shell component that houses the disclaimer and chatbot UI.
 * Used on the ChatbotEntry page to house static page content for
 * /contact-us/virtual-agent and provide the right-column chatbot container.
 * @component
 * @returns jsx.Element
 */
export const Shell = () => {
  useSkipLinkFix();

  const dispatch = useDispatch();

  // Redux state doesn't survive a refresh, so a signed-in user mid-conversation
  // would otherwise land back on the disclaimer screen instead of resuming.
  useEffect(() => {
    if (getDisclaimerAccepted()) {
      dispatch(chatbotActions.acceptDisclaimer());
    }
  }, [dispatch]);

  return (
    <div
      className="vads-l-grid-container desktop-lg:vads-u-padding-x--0"
      data-testid="chatbot-shell"
    >
      <div className="vads-l-row vads-u-margin-x--neg2p5 vads-u-margin-y--4">
        <div className="vads-l-col--12 vads-u-padding-x--2p5 medium-screen:vads-l-col--5 small-desktop-screen:vads-l-col--7">
          <LeftColumnContent />
        </div>
        <div
          className="vads-l-col--12 vads-u-padding-x--2p5 medium-screen:vads-l-col--7 small-desktop-screen:vads-l-col--5"
          data-testid="sticky-chatbot"
        >
          <RightColumnContent
            onAccept={() => {
              setDisclaimerAccepted(true);
              dispatch(chatbotActions.acceptDisclaimer());
            }}
          />
        </div>
      </div>
    </div>
  );
};
